import { Box, Grid, GridItem, Text, Badge, Icon } from '@chakra-ui/react';
import { PhoneIcon, CalendarIcon } from '@chakra-ui/icons';

interface ToolProp {
  enabled: boolean;
  action: () => void;
}

interface ActiveToolsProps {
  call_transfers: ToolProp;
  calendar_booking: ToolProp;
  integration_specifics: {
    call_transfers: Record<string, any>;
    calendar_booking: Record<string, any>;
  };
}

const toolList = [
  {
    key: 'call_transfers',
    label: 'Call Transfers',
    icon: PhoneIcon,
    description: 'Route calls to specialists',
  },
  {
    key: 'calendar_booking',
    label: 'Calendar Booking',
    icon: CalendarIcon,
    description: 'Schedule appointments',
  },
];

const ActiveTools = ({ call_transfers, calendar_booking, integration_specifics }: ActiveToolsProps) => {
  const tools = [
    {
      ...toolList[0],
      active: call_transfers.enabled,
      onClick: call_transfers.action,
    },
    {
      ...toolList[1],
      active: calendar_booking.enabled,
      onClick: calendar_booking.action,
    },
  ];

  return (
    <Box>
      <Text fontWeight="bold" mb={2}>
        Active Tools & Capabilities
      </Text>
      <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }} gap={4}>
        {tools.map((tool) => (
          <GridItem
            key={tool.key}
            bg={tool.active ? 'green.50' : 'gray.100'}
            borderRadius="md"
            border="1px solid"
            borderColor={tool.active ? 'green.200' : 'gray.200'}
            p={4}
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            minH="90px"
            style={{ cursor: 'pointer' }}
            onClick={tool.onClick}
          >
            <Box display="flex" alignItems="center" mb={1}>
              <Icon as={tool.icon} boxSize={5} mr={2} color={tool.active ? 'green.500' : 'gray.400'} />
              <Text fontWeight="semibold">{tool.label}</Text>
              {tool.active && (
                <Badge ml={2} colorScheme="green" fontSize="0.7em">
                  Active
                </Badge>
              )}
            </Box>
            <Text fontSize="sm" color="gray.700">
              {tool.description}
            </Text>
          </GridItem>
        ))}
      </Grid>
    </Box>
  );
};

export default ActiveTools;
